export class NotLoggedInError extends Error {
  readonly type?: string;
  constructor() {
    super('The user is not logged in.');
    this.type = 'NotLoggedInError';
  }
}
